import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// The hero image is preloaded via a <link rel="preload"> tag injected into
// index.html at build time (see preloadHeroPlugin in vite.config.ts), so the
// browser discovers it immediately without waiting for this JS to parse.

createRoot(document.getElementById("root")!).render(<App />);
